/* adpbtds-bmsm.js — All JS for the BMSM section — v2 */

(function() {
  var sectionEl = document.querySelector('.hdt-buy-more-save-more-section');
  if (!sectionEl) return;

  var sectionId = sectionEl.dataset.sectionId;
  var variantsScript = document.getElementById('bmsm-product-variants-' + sectionId);
  if (!variantsScript) return;
  var variantsData = JSON.parse(variantsScript.textContent);

  /* ── Hardcoded variant IDs (all 360 — bypasses Liquid's 250 cap) ── */
  var variantMap = {
'32A|Beige|1 Pair':51631915696418,'32A|Beige|2 Pairs':51631915729186,'32A|Beige|3 Pairs':51631915761954,
'32A|Onyx|1 Pair':51631915794722,'32A|Onyx|2 Pairs':51631915827490,'32A|Onyx|3 Pairs':51631915860258,
'32A|Caramel|1 Pair':51631915893026,'32A|Caramel|2 Pairs':51631915925794,'32A|Caramel|3 Pairs':51631915958562,
'32A|Ivory|1 Pair':51631915991330,'32A|Ivory|2 Pairs':51631916024098,'32A|Ivory|3 Pairs':51631916056866,
'32A|Cocoa|1 Pair':51631916089634,'32A|Cocoa|2 Pairs':51631916122402,'32A|Cocoa|3 Pairs':51631916155170,
'32B|Beige|1 Pair':51631916187938,'32B|Beige|2 Pairs':51631916220706,'32B|Beige|3 Pairs':51631916253474,
'32B|Onyx|1 Pair':51631916286242,'32B|Onyx|2 Pairs':51631916319010,'32B|Onyx|3 Pairs':51631916351778,
'32B|Caramel|1 Pair':51631916384546,'32B|Caramel|2 Pairs':51631916417314,'32B|Caramel|3 Pairs':51631916450082,
'32B|Ivory|1 Pair':51631916482850,'32B|Ivory|2 Pairs':51631916515618,'32B|Ivory|3 Pairs':51631916548386,
'32B|Cocoa|1 Pair':51631916581154,'32B|Cocoa|2 Pairs':51631916613922,'32B|Cocoa|3 Pairs':51631916646690,
'32C|Beige|1 Pair':51631916679458,'32C|Beige|2 Pairs':51631916712226,'32C|Beige|3 Pairs':51631916744994,
'32C|Onyx|1 Pair':51631916777762,'32C|Onyx|2 Pairs':51631916810530,'32C|Onyx|3 Pairs':51631916843298,
'32C|Caramel|1 Pair':51631916876066,'32C|Caramel|2 Pairs':51631916908834,'32C|Caramel|3 Pairs':51631916941602,
'32C|Ivory|1 Pair':51631916974370,'32C|Ivory|2 Pairs':51631917007138,'32C|Ivory|3 Pairs':51631917039906,
'32C|Cocoa|1 Pair':51631917072674,'32C|Cocoa|2 Pairs':51631917105442,'32C|Cocoa|3 Pairs':51631917138210,
'32D|Beige|1 Pair':51631917170978,'32D|Beige|2 Pairs':51631917203746,'32D|Beige|3 Pairs':51631917236514,
'32D|Onyx|1 Pair':51631917269282,'32D|Onyx|2 Pairs':51631917302050,'32D|Onyx|3 Pairs':51631917334818,
'32D|Caramel|1 Pair':51631917367586,'32D|Caramel|2 Pairs':51631917400354,'32D|Caramel|3 Pairs':51631917433122,
'32D|Ivory|1 Pair':51631917465890,'32D|Ivory|2 Pairs':51631917498658,'32D|Ivory|3 Pairs':51631917531426,
'32D|Cocoa|1 Pair':51631917564194,'32D|Cocoa|2 Pairs':51631917596962,'32D|Cocoa|3 Pairs':51631917629730,
'32E|Beige|1 Pair':51631917662498,'32E|Beige|2 Pairs':51631917695266,'32E|Beige|3 Pairs':51631917728034,
'32E|Onyx|1 Pair':51631917760802,'32E|Onyx|2 Pairs':51631917793570,'32E|Onyx|3 Pairs':51631917826338,
'32E|Caramel|1 Pair':51631917859106,'32E|Caramel|2 Pairs':51631917891874,'32E|Caramel|3 Pairs':51631917924642,
'32E|Ivory|1 Pair':51631917957410,'32E|Ivory|2 Pairs':51631917990178,'32E|Ivory|3 Pairs':51631918022946,
'32E|Cocoa|1 Pair':51631918055714,'32E|Cocoa|2 Pairs':51631918088482,'32E|Cocoa|3 Pairs':51631918121250,
'32F|Beige|1 Pair':51631918154018,'32F|Beige|2 Pairs':51631918186786,'32F|Beige|3 Pairs':51631918219554,
'32F|Onyx|1 Pair':51631918252322,'32F|Onyx|2 Pairs':51631918285090,'32F|Onyx|3 Pairs':51631918317858,
'32F|Caramel|1 Pair':51631918350626,'32F|Caramel|2 Pairs':51631918383394,'32F|Caramel|3 Pairs':51631918416162,
'32F|Ivory|1 Pair':51631918448930,'32F|Ivory|2 Pairs':51631918481698,'32F|Ivory|3 Pairs':51631918514466,
'32F|Cocoa|1 Pair':51631918547234,'32F|Cocoa|2 Pairs':51631918580002,'32F|Cocoa|3 Pairs':51631918612770,
'34A|Beige|1 Pair':51631918645538,'34A|Beige|2 Pairs':51631918678306,'34A|Beige|3 Pairs':51631918711074,
'34A|Onyx|1 Pair':51631918743842,'34A|Onyx|2 Pairs':51631918776610,'34A|Onyx|3 Pairs':51631918809378,
'34A|Caramel|1 Pair':51631918842146,'34A|Caramel|2 Pairs':51631918874914,'34A|Caramel|3 Pairs':51631918907682,
'34A|Ivory|1 Pair':51631918940450,'34A|Ivory|2 Pairs':51631918973218,'34A|Ivory|3 Pairs':51631919005986,
'34A|Cocoa|1 Pair':51631919038754,'34A|Cocoa|2 Pairs':51631919071522,'34A|Cocoa|3 Pairs':51631919104290,
'34B|Beige|1 Pair':51631919137058,'34B|Beige|2 Pairs':51631919169826,'34B|Beige|3 Pairs':51631919202594,
'34B|Onyx|1 Pair':51631919235362,'34B|Onyx|2 Pairs':51631919268130,'34B|Onyx|3 Pairs':51631919300898,
'34B|Caramel|1 Pair':51631919333666,'34B|Caramel|2 Pairs':51631919366434,'34B|Caramel|3 Pairs':51631919399202,
'34B|Ivory|1 Pair':51631919431970,'34B|Ivory|2 Pairs':51631919464738,'34B|Ivory|3 Pairs':51631919497506,
'34B|Cocoa|1 Pair':51631919530274,'34B|Cocoa|2 Pairs':51631919563042,'34B|Cocoa|3 Pairs':51631919595810,
'34C|Beige|1 Pair':51631919628578,'34C|Beige|2 Pairs':51631919661346,'34C|Beige|3 Pairs':51631919694114,
'34C|Onyx|1 Pair':51631919726882,'34C|Onyx|2 Pairs':51631919759650,'34C|Onyx|3 Pairs':51631919792418,
'34C|Caramel|1 Pair':51631919825186,'34C|Caramel|2 Pairs':51631919857954,'34C|Caramel|3 Pairs':51631919890722,
'34C|Ivory|1 Pair':51631919923490,'34C|Ivory|2 Pairs':51631919956258,'34C|Ivory|3 Pairs':51631919989026,
'34C|Cocoa|1 Pair':51631920021794,'34C|Cocoa|2 Pairs':51631920054562,'34C|Cocoa|3 Pairs':51631920087330,
'34D|Beige|1 Pair':51631920120098,'34D|Beige|2 Pairs':51631920152866,'34D|Beige|3 Pairs':51631920185634,
'34D|Onyx|1 Pair':51631920218402,'34D|Onyx|2 Pairs':51631920251170,'34D|Onyx|3 Pairs':51631920283938,
'34D|Caramel|1 Pair':51631920316706,'34D|Caramel|2 Pairs':51631920349474,'34D|Caramel|3 Pairs':51631920382242,
'34D|Ivory|1 Pair':51631920415010,'34D|Ivory|2 Pairs':51631920447778,'34D|Ivory|3 Pairs':51631920480546,
'34D|Cocoa|1 Pair':51631920513314,'34D|Cocoa|2 Pairs':51631920546082,'34D|Cocoa|3 Pairs':51631920578850,
'34E|Beige|1 Pair':51631920611618,'34E|Beige|2 Pairs':51631920644386,'34E|Beige|3 Pairs':51631920677154,
'34E|Onyx|1 Pair':51631920709922,'34E|Onyx|2 Pairs':51631920742690,'34E|Onyx|3 Pairs':51631920775458,
'34E|Caramel|1 Pair':51631920808226,'34E|Caramel|2 Pairs':51631920840994,'34E|Caramel|3 Pairs':51631920873762,
'34E|Ivory|1 Pair':51631920906530,'34E|Ivory|2 Pairs':51631920939298,'34E|Ivory|3 Pairs':51631920972066,
'34E|Cocoa|1 Pair':51631921004834,'34E|Cocoa|2 Pairs':51631921037602,'34E|Cocoa|3 Pairs':51631921070370,
'34F|Beige|1 Pair':51631921103138,'34F|Beige|2 Pairs':51631921135906,'34F|Beige|3 Pairs':51631921168674,
'34F|Onyx|1 Pair':51631921201442,'34F|Onyx|2 Pairs':51631921234210,'34F|Onyx|3 Pairs':51631921266978,
'34F|Caramel|1 Pair':51631921299746,'34F|Caramel|2 Pairs':51631921332514,'34F|Caramel|3 Pairs':51631921365282,
'34F|Ivory|1 Pair':51631921398050,'34F|Ivory|2 Pairs':51631921430818,'34F|Ivory|3 Pairs':51631921463586,
'34F|Cocoa|1 Pair':51631921496354,'34F|Cocoa|2 Pairs':51631921529122,'34F|Cocoa|3 Pairs':51631921561890,
'36A|Beige|1 Pair':51631921594658,'36A|Beige|2 Pairs':51631921627426,'36A|Beige|3 Pairs':51631921660194,
'36A|Onyx|1 Pair':51631921692962,'36A|Onyx|2 Pairs':51631921725730,'36A|Onyx|3 Pairs':51631921758498,
'36A|Caramel|1 Pair':51631921791266,'36A|Caramel|2 Pairs':51631921824034,'36A|Caramel|3 Pairs':51631921856802,
'36A|Ivory|1 Pair':51631921889570,'36A|Ivory|2 Pairs':51631921922338,'36A|Ivory|3 Pairs':51631921955106,
'36A|Cocoa|1 Pair':51631921987874,'36A|Cocoa|2 Pairs':51631922020642,'36A|Cocoa|3 Pairs':51631922053410,
'36B|Beige|1 Pair':51631922086178,'36B|Beige|2 Pairs':51631922118946,'36B|Beige|3 Pairs':51631922151714,
'36B|Onyx|1 Pair':51631922184482,'36B|Onyx|2 Pairs':51631922217250,'36B|Onyx|3 Pairs':51631922250018,
'36B|Caramel|1 Pair':51631922282786,'36B|Caramel|2 Pairs':51631922315554,'36B|Caramel|3 Pairs':51631922348322,
'36B|Ivory|1 Pair':51631922381090,'36B|Ivory|2 Pairs':51631922413858,'36B|Ivory|3 Pairs':51631922446626,
'36B|Cocoa|1 Pair':51631922479394,'36B|Cocoa|2 Pairs':51631922512162,'36B|Cocoa|3 Pairs':51631922544930,
'36C|Beige|1 Pair':51631922577698,'36C|Beige|2 Pairs':51631922610466,'36C|Beige|3 Pairs':51631922643234,
'36C|Onyx|1 Pair':51631922676002,'36C|Onyx|2 Pairs':51631922708770,'36C|Onyx|3 Pairs':51631922741538,
'36C|Caramel|1 Pair':51631922774306,'36C|Caramel|2 Pairs':51631922807074,'36C|Caramel|3 Pairs':51631922839842,
'36C|Ivory|1 Pair':51631922872610,'36C|Ivory|2 Pairs':51631922905378,'36C|Ivory|3 Pairs':51631922938146,
'36C|Cocoa|1 Pair':51631922970914,'36C|Cocoa|2 Pairs':51631923003682,'36C|Cocoa|3 Pairs':51631923036450,
'36D|Beige|1 Pair':51631923069218,'36D|Beige|2 Pairs':51631923101986,'36D|Beige|3 Pairs':51631923134754,
'36D|Onyx|1 Pair':51631923167522,'36D|Onyx|2 Pairs':51631923200290,'36D|Onyx|3 Pairs':51631923233058,
'36D|Caramel|1 Pair':51631923265826,'36D|Caramel|2 Pairs':51631923298594,'36D|Caramel|3 Pairs':51631923331362,
'36D|Ivory|1 Pair':51631923364130,'36D|Ivory|2 Pairs':51631923396898,'36D|Ivory|3 Pairs':51631923429666,
'36D|Cocoa|1 Pair':51631923462434,'36D|Cocoa|2 Pairs':51631923495202,'36D|Cocoa|3 Pairs':51631923527970,
'36E|Beige|1 Pair':51631923560738,'36E|Beige|2 Pairs':51631923593506,'36E|Beige|3 Pairs':51631923626274,
'36E|Onyx|1 Pair':51631923659042,'36E|Onyx|2 Pairs':51631923691810,'36E|Onyx|3 Pairs':51631923724578,
'36E|Caramel|1 Pair':51631923757346,'36E|Caramel|2 Pairs':51631923790114,'36E|Caramel|3 Pairs':51631923822882,
'36E|Ivory|1 Pair':51631923855650,'36E|Ivory|2 Pairs':51631923888418,'36E|Ivory|3 Pairs':51631923921186,
'36E|Cocoa|1 Pair':51631923953954,'36E|Cocoa|2 Pairs':51631923986722,'36E|Cocoa|3 Pairs':51631924019490,
'38A|Beige|1 Pair':51631924052258,'38A|Beige|2 Pairs':51631924085026,'38A|Beige|3 Pairs':51631924117794,
'38A|Onyx|1 Pair':51631924150562,'38A|Onyx|2 Pairs':51631924183330,'38A|Onyx|3 Pairs':51631924216098,
'38A|Caramel|1 Pair':51631924248866,'38A|Caramel|2 Pairs':51631924281634,'38A|Caramel|3 Pairs':51631924314402,
'38A|Ivory|1 Pair':51631924347170,'38A|Ivory|2 Pairs':51631924379938,'38A|Ivory|3 Pairs':51631924412706,
'38A|Cocoa|1 Pair':51631924445474,'38A|Cocoa|2 Pairs':51631924478242,'38A|Cocoa|3 Pairs':51631924511010,
'38B|Beige|1 Pair':51631924543778,'38B|Beige|2 Pairs':51631924576546,'38B|Beige|3 Pairs':51631924609314,
'38B|Onyx|1 Pair':51631924642082,'38B|Onyx|2 Pairs':51631924674850,'38B|Onyx|3 Pairs':51631924707618,
'38B|Caramel|1 Pair':51631924740386,'38B|Caramel|2 Pairs':51631924773154,'38B|Caramel|3 Pairs':51631924805922,
'38B|Ivory|1 Pair':51631924838690,'38B|Ivory|2 Pairs':51631924871458,'38B|Ivory|3 Pairs':51631924904226,
'38B|Cocoa|1 Pair':51631924936994,'38B|Cocoa|2 Pairs':51631924969762,'38B|Cocoa|3 Pairs':51631925002530,
'38C|Beige|1 Pair':51631925035298,'38C|Beige|2 Pairs':51631925068066,'38C|Beige|3 Pairs':51631925100834,
'38C|Onyx|1 Pair':51631925133602,'38C|Onyx|2 Pairs':51631925166370,'38C|Onyx|3 Pairs':51631925199138,
'38C|Caramel|1 Pair':51631925231906,'38C|Caramel|2 Pairs':51631925264674,'38C|Caramel|3 Pairs':51631925297442,
'38C|Ivory|1 Pair':51631925330210,'38C|Ivory|2 Pairs':51631925362978,'38C|Ivory|3 Pairs':51631925395746,
'38C|Cocoa|1 Pair':51631925428514,'38C|Cocoa|2 Pairs':51631925461282,'38C|Cocoa|3 Pairs':51631925494050,
'38D|Beige|1 Pair':51631925526818,'38D|Beige|2 Pairs':51631925559586,'38D|Beige|3 Pairs':51631925592354,
'38D|Onyx|1 Pair':51631925625122,'38D|Onyx|2 Pairs':51631925657890,'38D|Onyx|3 Pairs':51631925690658,
'38D|Caramel|1 Pair':51631925723426,'38D|Caramel|2 Pairs':51631925756194,'38D|Caramel|3 Pairs':51631925788962,
'38D|Ivory|1 Pair':51631925821730,'38D|Ivory|2 Pairs':51631925854498,'38D|Ivory|3 Pairs':51631925887266,
'38D|Cocoa|1 Pair':51631925920034,'38D|Cocoa|2 Pairs':51631925952802,'38D|Cocoa|3 Pairs':51631925985570,
'40A|Beige|1 Pair':51631926018338,'40A|Beige|2 Pairs':51631926051106,'40A|Beige|3 Pairs':51631926083874,
'40A|Onyx|1 Pair':51631926116642,'40A|Onyx|2 Pairs':51631926149410,'40A|Onyx|3 Pairs':51631926182178,
'40A|Caramel|1 Pair':51631926214946,'40A|Caramel|2 Pairs':51631926247714,'40A|Caramel|3 Pairs':51631926280482,
'40A|Ivory|1 Pair':51631926313250,'40A|Ivory|2 Pairs':51631926346018,'40A|Ivory|3 Pairs':51631926378786,
'40A|Cocoa|1 Pair':51631926411554,'40A|Cocoa|2 Pairs':51631926444322,'40A|Cocoa|3 Pairs':51631926477090,
'40B|Beige|1 Pair':51631926509858,'40B|Beige|2 Pairs':51631926542626,'40B|Beige|3 Pairs':51631926575394,
'40B|Onyx|1 Pair':51631926608162,'40B|Onyx|2 Pairs':51631926640930,'40B|Onyx|3 Pairs':51631926673698,
'40B|Caramel|1 Pair':51631926706466,'40B|Caramel|2 Pairs':51631926739234,'40B|Caramel|3 Pairs':51631926772002,
'40B|Ivory|1 Pair':51631926804770,'40B|Ivory|2 Pairs':51631926837538,'40B|Ivory|3 Pairs':51631926870306,
'40B|Cocoa|1 Pair':51631926903074,'40B|Cocoa|2 Pairs':51631926935842,'40B|Cocoa|3 Pairs':51631926968610,
'40C|Beige|1 Pair':51631927001378,'40C|Beige|2 Pairs':51631927034146,'40C|Beige|3 Pairs':51631927066914,
'40C|Onyx|1 Pair':51631927099682,'40C|Onyx|2 Pairs':51631927132450,'40C|Onyx|3 Pairs':51631927165218,
'40C|Caramel|1 Pair':51631927197986,'40C|Caramel|2 Pairs':51631927230754,'40C|Caramel|3 Pairs':51631927263522,
'40C|Ivory|1 Pair':51631927296290,'40C|Ivory|2 Pairs':51631927329058,'40C|Ivory|3 Pairs':51631927361826,
'40C|Cocoa|1 Pair':51631927394594,'40C|Cocoa|2 Pairs':51631927427362,'40C|Cocoa|3 Pairs':51631927460130
  };

  /* ── Helpers ── */
  function getSelectedColor() {
    var radio = sectionEl.querySelector('fieldset.is-style-color input[type="radio"]:checked');
    if (radio) return radio.value;
    var label = sectionEl.querySelector('fieldset.is-style-color [update-value]');
    return label ? label.textContent.trim() : '';
  }

  /* ── 1. Checkout ── */
  var checkoutBtn = document.getElementById('bmsm-checkout-btn-' + sectionId);
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function() {
      var btn = this;
      if (btn.getAttribute('aria-busy') === 'true') return;

      var sizeInput = sectionEl.querySelector('input[is-value][name="option1"]');
      var size = sizeInput ? sizeInput.value : '';
      var color = getSelectedColor();

      var activeRow = sectionEl.querySelector('.hdt-bmsm-bundle-row.active');
      var bundleQty = activeRow ? parseInt(activeRow.getAttribute('data-qty')) : 1;
      var qtyStr = bundleQty === 1 ? '1 Pair' : bundleQty + ' Pairs';

      // Check stock map first — must be in stock for this color+size
      if (!stock[color] || stock[color].indexOf(size) === -1) return;

      var key = size + '|' + color + '|' + qtyStr;
      var variantId = variantMap[key];
      if (!variantId) return;

      btn.setAttribute('aria-busy', 'true');
      btn.querySelector('.hdt-btn-atc_text').textContent = 'PROCESSING...';
      fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
        .then(function(res) { return res.json(); })
        .then(function() {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          });
        })
        .then(function(res) { return res.json(); })
        .then(function(data) {
          if (data.items || data.id) {
            window.location.href = '/checkout';
          } else {
            btn.removeAttribute('aria-busy');
            btn.querySelector('.hdt-btn-atc_text').textContent = 'CHECKOUT';
          }
        })
        .catch(function() {
          btn.removeAttribute('aria-busy');
          btn.querySelector('.hdt-btn-atc_text').textContent = 'CHECKOUT';
        });
    });
  }

  /* ── 2. Dialog patch (non-modal) ── */
  function patchDialogs() {
    sectionEl.querySelectorAll('.hdt-popover-variant').forEach(function(dialog) {
      if (dialog._bmsmPatched) return;
      dialog._bmsmPatched = true;
      dialog.showModal = function() { if (!this.open) this.show(); };
    });
  }
  patchDialogs();
  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(patchDialogs).observe(sectionEl, { childList: true, subtree: true });
  }
  document.addEventListener('click', function(e) {
    sectionEl.querySelectorAll('.hdt-popover-variant[open]').forEach(function(dialog) {
      var popover = dialog.closest('hdt-popover');
      var trigger = popover ? popover.previousElementSibling : null;
      if (!dialog.contains(e.target) && e.target !== trigger && (!trigger || !trigger.contains(e.target))) {
        dialog.close();
      }
    });
  });

  /* ── 3. Bundle row selection ── */
  window.selectBundle = function(el, qty) {
    sectionEl.querySelectorAll('.hdt-bmsm-bundle-row').forEach(function(i) {
      i.classList.remove('active');
      var radio = i.querySelector('input[type="radio"]');
      if (radio) radio.checked = false;
    });
    el.classList.add('active');
    var activeRadio = el.querySelector('input[type="radio"]');
    if (activeRadio) activeRadio.checked = true;
    var form = sectionEl.querySelector('form');
    if (form) form.querySelector('input[name="quantity"]').value = qty;
  };

  /* ── 4. Product Switcher ── */
  sectionEl.querySelectorAll('.custom-listing-item').forEach(function(item) {
    item.addEventListener('click', function() {
      sectionEl.querySelectorAll('.custom-listing-item').forEach(function(i) { i.classList.remove('cat-active'); });
      sectionEl.querySelectorAll('.tab-content').forEach(function(c) { c.classList.remove('active'); });
      item.classList.add('cat-active');
      var targetId = item.dataset.target;
      sectionEl.querySelector('#' + targetId).classList.add('active');
    });
  });

  /* ── 5. Variant image handler ── */
  var imgScripts = sectionEl.querySelectorAll('script[id^="bmsm-variant-images-"]');
  imgScripts.forEach(function(script) {
    var variantImages = {};
    try { variantImages = JSON.parse(script.textContent); } catch(e) {}
    if (Object.keys(variantImages).length === 0) return;

    function updateImages() {
      var selectedOptions = Array.from(sectionEl.querySelectorAll('.hdt-variant-picker input[type="radio"]:checked, .hdt-variant-picker select'))
        .map(function(el) { return el.value.toLowerCase().trim(); });

      var matchedImages = null;
      for (var oi = 0; oi < selectedOptions.length; oi++) {
        if (variantImages[selectedOptions[oi]]) { matchedImages = variantImages[selectedOptions[oi]]; break; }
      }

      sectionEl.querySelectorAll('.hdt-bmsm-bundle-row').forEach(function(bundle, index) {
        var variantImg = matchedImages ? matchedImages[index] : null;
        var thumb = bundle.querySelector('.hdt-bmsm-bundle-thumb');
        if (!thumb) return;

        var defaultImgs = [null, null, null];
        try { defaultImgs = JSON.parse(bundle.dataset.defaultImages || '[]'); } catch(e) {}

        var qtyBadge = thumb.querySelector('.hdt-bmsm-bundle-qty-badge');

        if (variantImg) {
          var stack = thumb.querySelector('.hdt-bmsm-bundle-thumb-stack');
          if (stack) stack.remove();
          var imgEl = thumb.querySelector('.hdt-bmsm-bundle-img');
          if (imgEl) { imgEl.src = variantImg; imgEl.srcset = variantImg; }
          else {
            var newImg = document.createElement('img');
            newImg.className = 'hdt-bmsm-bundle-img';
            newImg.src = variantImg;
            if (qtyBadge) thumb.insertBefore(newImg, qtyBadge); else thumb.appendChild(newImg);
          }
          thumb.style.display = '';
        } else {
          var validDefaults = defaultImgs.filter(function(d) { return d !== null; });
          if (validDefaults.length >= 1) {
            var imgEl2 = thumb.querySelector('.hdt-bmsm-bundle-img');
            if (imgEl2) { imgEl2.src = validDefaults[0]; imgEl2.srcset = validDefaults[0]; }
            else {
              var newImg2 = document.createElement('img');
              newImg2.className = 'hdt-bmsm-bundle-img';
              newImg2.src = validDefaults[0];
              if (qtyBadge) thumb.insertBefore(newImg2, qtyBadge); else thumb.appendChild(newImg2);
            }
            thumb.style.display = '';
          }
        }
      });
    }

    sectionEl.addEventListener('change', function(e) {
      if (e.target.closest('hdt-variant-picker')) updateImages();
    });
    setTimeout(updateImages, 100);
  });

  /* ── 6. Size label update ── */
  var sizeEquivalents = {
    'AA':'28A, 30A, 32A, 28B, 30B, 28C','A':'34A, 32B, 30C, 28D','B':'36A, 34B, 32C, 30D, 28DD/E',
    'C':'38A, 36B, 34C, 32D, 30DD/E, 28DDD/F','D':'40A, 38B, 36C, 34D, 32DD/E, 30DDD/F, 28G',
    'E':'42A, 40B, 38C, 36D, 34DD/E, 32DDD/F, 30G, 28H','F':'44A, 42B, 40C, 38D, 36DD/E, 34DDD/F, 32G, 30H, 28I',
    'G':'44B, 42C, 40D, 38DD/E, 36DDD/F, 34G, 32H, 30I, 28J','H':'44C, 42D, 40DD/E, 38DDD/F, 36G, 34H, 32I, 30J, 28K',
    'I':'44D, 42DD/E, 40DDD/F, 38G, 36H, 34I, 32J, 30K, 28L','J':'44DD/E, 42DDD/F, 40G, 38H, 36I, 34J, 32K, 30L, 28M',
    'K':'44DDD/F, 42G, 40H, 38I, 36J, 34K, 32L, 30M, 28N','L':'44G, 42H, 40I, 38J, 36K, 34L, 32M, 30N, 28O',
    'M':'44H, 42I, 40J, 38K, 36L, 34M, 32N, 30O, 28P','N':'44I, 42J, 40K, 38L, 36M, 34N, 32O, 30P, 28Q',
    'O':'42K, 40L, 38M, 36N, 34O, 32P, 30Q, 28R','P':'42L, 40M, 38N, 36O, 34P, 32Q, 30R',
    'Q':'42M, 40N, 38O, 36P, 34Q, 32R, 30S','R':'44M, 42N, 40O, 38P, 36Q, 34R, 32S, 30T, 28U',
    'A/B':'34A, 32B, 30C, 28D','C/D':'38A, 36B, 34C, 32D, 30DD/E',
    'DD/E/F':'44A, 42B, 40C, 38D, 36DD/E, 34DDD/F','G/H':'44C, 42D, 40DD/E, 38DDD/F, 36G, 34H, 32I, 30J, 28K',
    'I/J/K':'44D, 42DD/E, 40DDD/F, 38G, 36H, 34I, 32J, 30K, 28L'
  };
  document.addEventListener('change', function(e) {
    var target = e.target;
    if (target.matches('hdt-richlist') || (target.tagName === 'INPUT' && target.closest('fieldset.is-style-size'))) {
      var fieldset = target.closest('fieldset.is-style-size');
      if (!fieldset) return;
      var val = target.getAttribute('selected') || target.value;
      if (!val) return;
      var labelSpan = fieldset.querySelector('[update-value]');
      if (labelSpan) labelSpan.textContent = val;
      var selectBtn = fieldset.querySelector('button.hdt-select');
      if (selectBtn) selectBtn.textContent = 'SIZE ' + val;
    }
  });

  /* ── 7. Sync variant ID to form ── */
  var formEl = document.getElementById(sectionEl.querySelector('form') ? sectionEl.querySelector('form').id : '');
  function syncVariantId() {
    var sizeInput = sectionEl.querySelector('input[is-value][name="option1"]');
    var size = sizeInput ? sizeInput.value : '';
    var color = getSelectedColor();
    if (!size || !color) return;

    var match = variantsData.find(function(v) {
      return v.options[0] === size && v.options[1] === color && v.options[2] === '1 Pair';
    });
    if (match && formEl) {
      var idInput = formEl.querySelector('input[name="id"]');
      if (idInput) idInput.value = match.id;
    }
  }
  sectionEl.addEventListener('change', syncVariantId);
  sectionEl.addEventListener('click', function() { setTimeout(syncVariantId, 100); });
  setTimeout(syncVariantId, 500);

  /* ── 8. Hardcoded stock map — sizes with 1 Pair qty > 0 per color ── */
  var stock = {                       
    'Beige':   ['32A','32B','32C','32D','32E','32F','34A','34B','34C','34D','34E','34F','36A','36B','36C','36D','36E','38A','38B','38C','38D','40A','40B','40C'],
    'Onyx':    ['32A','32B','32C','32D','32E','32F','34A','34B','34C','34D','34E','34F','36A','36B','36C','36D','36E','38A','38B','38C','38D','40A','40B','40C'],
    'Caramel': ['32A','32B','32C','32D','32E','32F','34A','34B','34C','34D','34E','34F','36A','36B','36C','36E','38A','38B','38C','38D','40A','40B','40C'],
    'Ivory':   ['32A','32B','32C','32D','32E','32F','34A','34B','34C','34D','34E','34F','36A','36B','36C','36D','36E','38A','38B','38C','38D','40A','40B','40C'],
    'Cocoa':   ['32A','32B','32C','32D','32E','32F','34A','34B','34C','34D','34E','34F','36A','36B','36C','36D','36E','38A','38B','38C','38D','40A','40B','40C']
  };

  function filterSizes() {
    var color = getSelectedColor();
    if (!color || !stock[color]) return;
    var ok = {};
    stock[color].forEach(function(s) { ok[s] = 1; });
    var buttons = sectionEl.querySelectorAll('fieldset.is-style-size [role="option"]');
    if (!buttons.length) buttons = sectionEl.querySelectorAll('fieldset[data-index="0"] [role="option"]');
    buttons.forEach(function(btn) {
      btn.style.display = ok[btn.getAttribute('value')] ? '' : 'none';
    });
  }

  filterSizes();
  setTimeout(filterSizes, 300);
  setTimeout(filterSizes, 800);
  document.addEventListener('DOMContentLoaded', filterSizes);
  sectionEl.querySelectorAll('fieldset.is-style-color input[type="radio"]').forEach(function(radio) {
    radio.addEventListener('change', function() { setTimeout(filterSizes, 50); });
  });
  sectionEl.querySelectorAll('fieldset.is-style-color label').forEach(function(label) {
    label.addEventListener('click', function() { setTimeout(filterSizes, 100); });
  });
  sectionEl.addEventListener('click', function() { setTimeout(filterSizes, 150); });
  setInterval(filterSizes, 800);

})();


/* ── Fitsize subtext + 1-line pill toggle (AU Plunge after BOOMBA rename) ── */
(function() {
  // BOOMBA picker label → AU local equivalent (subtext)
  var sizeFitMap = {
    '32A': '10A',
    '32B': '10B',
    '32C': '10C',
    '32D': '10D',
    '32E': '10E',
    '32F': '10F',
    '34A': '12A',
    '34B': '12B',
    '34C': '12C',
    '34D': '12D',
    '34E': '12E',
    '34F': '12F',
    '36A': '14A',
    '36B': '14B',
    '36C': '14C',
    '36D': '14D',
    '36E': '14E',
    '38A': '16A',
    '38B': '16B',
    '38C': '16C',
    '38D': '16D',
    '40A': '18A',
    '40B': '18B',
    '40C': '18C'
  };

  function checkSelectLineCount(btn) {
    if (!btn) return;
    btn.classList.remove('is-oneline');
    var style = getComputedStyle(btn);
    var lineHeight = parseFloat(style.lineHeight) || 22;
    var paddingTop = parseFloat(style.paddingTop) || 0;
    var paddingBottom = parseFloat(style.paddingBottom) || 0;
    var contentHeight = btn.scrollHeight - paddingTop - paddingBottom;
    if (contentHeight <= lineHeight * 1.3) {
      btn.classList.add('is-oneline');
    }
  }

  // Renders the button text for a given size. Pure function — no DOM reads.
  function renderBtnText(size) {
    if (!size) return 'Choose an option';
    var sub = sizeFitMap[size] || '';
    return (sub && sub !== size) ? (size + ' fits bra sizes: ' + sub) : ('SIZE ' + size);
  }

  function applyToBtn(btn, size) {
    if (!btn) return;
    var text = renderBtnText(size);
    if (btn.textContent !== text) btn.textContent = text;
    checkSelectLineCount(btn);
  }

  function getBtn() {
    var sec = document.querySelector('.hdt-buy-more-save-more-section');
    if (!sec) return null;
    return sec.querySelector('fieldset.is-style-size button.hdt-select');
  }

  function getCurrentSize() {
    var sec = document.querySelector('.hdt-buy-more-save-more-section');
    if (!sec) return '';
    var sizeInput = sec.querySelector('input[is-value][name="option1"]');
    return sizeInput ? (sizeInput.value || '').trim() : '';
  }

  function updateSizeBtn() {
    applyToBtn(getBtn(), getCurrentSize());
  }

  function init() {
    updateSizeBtn();

    // SYNCHRONOUS update on click — fires BEFORE Shopify's native handler can reset
    // the button text. Uses capture phase + click target value directly.
    document.addEventListener('click', function(e) {
      var optBtn = e.target && e.target.closest && e.target.closest('hdt-richlist button[role="option"], hdt-richlist button[value]');
      if (!optBtn) return;
      var fieldset = optBtn.closest('fieldset.is-style-size');
      if (!fieldset) return;
      var newSize = (optBtn.getAttribute('value') || optBtn.textContent || '').trim();
      if (!newSize) return;
      var btn = fieldset.querySelector('button.hdt-select');
      applyToBtn(btn, newSize);
    }, true);

    // Synchronous update on change (no setTimeout) — read from the change target directly
    document.addEventListener('change', function(e) {
      var t = e.target;
      if (!t || !t.matches) return;
      var fieldset = (t.closest && t.closest('fieldset.is-style-size')) || null;
      if (!fieldset) return;
      var newSize = '';
      if (t.matches('hdt-richlist')) {
        newSize = (t.getAttribute('selected') || '').trim();
      } else if (t.tagName === 'INPUT') {
        newSize = (t.value || '').trim();
      }
      if (!newSize) newSize = getCurrentSize();
      var btn = fieldset.querySelector('button.hdt-select');
      applyToBtn(btn, newSize);
    }, true);

    // MutationObserver — catches any external text change on the button and re-applies
    // our fitsize subtext immediately. Eliminates remaining flicker windows.
    function watchBtn() {
      var btn = getBtn();
      if (!btn || btn._fitsizeObserved) return;
      btn._fitsizeObserved = true;
      var observing = false;
      var observer = new MutationObserver(function() {
        if (observing) return;
        var size = getCurrentSize();
        var expected = renderBtnText(size);
        if (btn.textContent !== expected) {
          observing = true;
          btn.textContent = expected;
          checkSelectLineCount(btn);
          observing = false;
        }
      });
      observer.observe(btn, { childList: true, characterData: true, subtree: true });
    }
    watchBtn();

    // Final safety net — re-attach observer if button gets replaced in DOM
    setTimeout(watchBtn, 200);
    setTimeout(watchBtn, 800);
    setTimeout(updateSizeBtn, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
